import { PageLayout } from '~/components/PageLayout/PageLayout';
import { PersonSerializerDetailed } from '~/apis/ssf';
import { Table } from '~/components/Table/Table';
import { Fragment } from 'react/jsx-runtime';
import { useAuthentication } from '~/hooks/useAuthentication';
import { Badge } from '~/components/Badge/Badge';

interface Props {
  person: Pick<PersonSerializerDetailed, 'club' | 'license_id' | 'is_para' | 'is_ifn'>;
}

export function LifterBasicInfo({ person }: Props) {
  const { isSuperUser } = useAuthentication();

  return (
    <Fragment>
      <PageLayout.SubHeading>Generell information</PageLayout.SubHeading>

      <Table bg="odd">
        <Table.Body>
          <Table.Row>
            <Table.Col as="th">Licens</Table.Col>
            <Table.Col>{person.license_id}</Table.Col>
          </Table.Row>
          <Table.Row>
            <Table.Col as="th">Förening</Table.Col>
            <Table.Col>{person.club.name}</Table.Col>
          </Table.Row>
          <Table.Row>
            <Table.Col as="th">Distrikt</Table.Col>
            <Table.Col>{person.club.district.name}</Table.Col>
          </Table.Row>
          {isSuperUser && (
            <Table.Row>
              <Table.Col as="th">Behörighet</Table.Col>
              <Table.Col>
                {person.is_para && (
                  <span style={{ marginRight: 'var(--size-3)' }}>
                    <Badge variant="default" label="Para" />
                  </span>
                )}
                {person.is_ifn && <Badge variant="default" label="IFN" />}
              </Table.Col>
            </Table.Row>
          )}
        </Table.Body>
      </Table>
    </Fragment>
  );
}
